import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import ShelvesList from '@shared/shelves/ShelvesList'

import { shelfService } from '@services/operator/shelfService'

export default function OperatorShelvesList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { shelfTypes } = useOperatorData()
  const { addJob } = useOperatorNotification()

  return (
    <div>
      <ListPageHeader
        items={['stocks', 'stocks.shelves']}
        actions={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/shelves/batch_new')}>
            {t('common.button.new')}
          </Button>
        }
      />
      <ShelvesList
        service={shelfService}
        role="operator"
        shelfTypes={shelfTypes}
        addJob={addJob}
      />
    </div>
  )
}
